import React from 'react';

import './ComentariosDoVeiculo.css';

/**
 * O selo de comentários de um pedido ou de uma requisição (at-129; redesenhado na
 * transversal/at-90).
 *
 * Victor, 23/10/2026, vendo o número cinza ao lado do pedido: "chama atenção nenhuma. Melhore, e
 * coloque do lado extremo direito da linha". Virou uma pílula laranja com ícone e o texto por
 * extenso ("1 comentário"), presa à borda direita da linha (`posicao="direita"`, o padrão). A
 * última célula da linha ganha recuo no CSS para o selo não cobrir o valor.
 *
 * ⚠️ Zero (ou ausente) não desenha nada: "sem selo" não afirma que ninguém comentou — quem afirma
 * isso é a seção de comentários do detalhe, que tem estado de erro próprio.
 *
 * ⚠️ `posicao="inline"` é para o selo dentro de uma frase (os resíduos dos cards), onde não há
 * linha de tabela para prendê-lo.
 */
const SeloDeComentarios: React.FC<{
  total?: number | null;
  /**
   * O que o número CONTA, quando não são comentários. Na linha de grupo dos cards da aba Pedidos
   * ele conta pedidos com comentário — dizer "3 comentários" ali seria falso.
   */
  rotuloDe?: (total: number) => string;
  posicao?: 'direita' | 'inline';
}> = ({ total, rotuloDe, posicao = 'direita' }) => {
  if (!total || total <= 0) return null;
  const rotulo = rotuloDe ? rotuloDe(total) : `${total} ${total === 1 ? 'comentário' : 'comentários'}`;
  return (
    <span className={`selo-comentarios selo-comentarios--${posicao}`} title={rotulo} aria-label={rotulo}>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </svg>
      {rotulo}
    </span>
  );
};

export default SeloDeComentarios;
